import UseDifferentAccountButton from '../components/UseDifferentAccountButton';
import type { MfaMethodType } from '../../../../shared/model-typings/mfaMethod';
import type { Candidate } from '../../../../shared/types/routes/auth/v2';

import CredentialForm from './CredentialForm';

import styles from '../Login.module.less';

export type MethodsStepProps = {
  org: Candidate;
  identifier: string;
  next?: string;
  onMfaRequired: (mfaMethod: MfaMethodType) => void;
  onBack: () => void;
};

/**
 * Renders the sign-in method for the org the user picked. Password and LDAP orgs share one credential form (the
 * backend selects the strategy), so it shows for any org with a credential method. SSO-only orgs (SAML / Google) have
 * no form yet and fall back to a placeholder.
 */
const MethodsStep = ({ org, identifier, next, onMfaRequired, onBack }: MethodsStepProps) => {
  const hasCredentialMethod = org.availableMethods.some(
    method => method.type === 'password' || method.type === 'ldap',
  );
  const hasPasswordMethod = org.availableMethods.some(method => method.type === 'password');

  if (hasCredentialMethod) {
    return (
      <CredentialForm
        org={org}
        identifier={identifier}
        showForgotPassword={hasPasswordMethod}
        next={next}
        onMfaRequired={onMfaRequired}
        onBack={onBack}
      />
    );
  }

  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>{org.organizationName}</h1>
      <p className={styles.placeholder} data-test-id="sso-unsupported">
        This organization uses single sign-on, which is not available here yet.
      </p>
      <UseDifferentAccountButton onClick={onBack} />
    </div>
  );
};

export default MethodsStep;
